export default function() {
  return {
    userData: {},
    fetchedUserData: false,
    csrfToken: ''
  };
}
